import "./scss/style.scss";
import { gsap } from "gsap";

$(function () {
	/* NAVIGATION */

	/* HEADER SEARCH */
	var headeSearchOpen = gsap.timeline({
		repeat: 0,
		repeatDelay: 1,
		paused: true,
	});
	var headeSearchBarOpen = gsap.timeline({
		repeat: 0,
		repeatDelay: 1,
		paused: true,
	});

	headeSearchBarOpen.to(".we-header-search-container", {
		duration: 0.1,
		width: "100%",
		opacity: "1",
	});

	//

	headeSearchOpen.set(".search-icon svg", {
		display: "block",
	});
	headeSearchOpen.to(".search-icon svg", {
		duration: 0.3,
		opacity: "0",
	});
	headeSearchOpen.set(".search-icon svg", {
		display: "none",
	});
	headeSearchOpen.set(".search-icon .we-xlose", {
		display: "block",
		opacity: "0",
	});
	headeSearchOpen.to(".search-icon .we-xlose", {
		duration: 0.3,
		opacity: "0.5",
	});

	function showHideHeaderNavigation() {
		if ($(".search-icon").hasClass("closed")) {
			$(".search-icon").removeClass("closed");
			headeSearchBarOpen.play();
			headeSearchOpen.play();
		} else {
			$(".search-icon").addClass("closed");
			headeSearchOpen.reverse();
			headeSearchBarOpen.reverse();
		}
	}

	$(".search-icon").on("click", function (e) {
		e.preventDefault();
		showHideHeaderNavigation();
	});
	/* END HEADER SEARCH */

	/* HEADER NAV */
	$(".header-ls-navigation ul li.has-children").hover(
		function () {
			// over

			$(this).addClass("we-header-sub-opened");

			var headeNAvSubOpen = gsap.timeline({
				repeat: 0,
				repeatDelay: 1,
			});

			headeNAvSubOpen.set($(this).find(".we-header-submenu"), {
				display: "block",
			});

			headeNAvSubOpen.to($(this).find(".we-header-submenu"), {
				duration: 0.2,
				top: "100%",
				opacity: "1",
			});

			headeNAvSubOpen.play();
		},
		function () {
			// out

			$(this).removeClass("we-header-sub-opened");

			var headeNAvSubClose = gsap.timeline({
				repeat: 0,
				repeatDelay: 1,
			});

			headeNAvSubClose.to(
				$(this).find(".we-header-submenu"),
				{
					duration: 0.2,
					top: "-20%", // or whichever value you initially set
					opacity: "0",
				},
				"+=0.2"
			);

			headeNAvSubClose.set($(this).find(".we-header-submenu"), {
				display: "none",
			});

			headeNAvSubClose.play();
		}
	);

	//SMALL SCREEN NAV
	let screenHeight = window.innerHeight;
	let mobileNavHeight = screenHeight - 48; //HEADER HEIGHT

	var mobileNavOpen = gsap.timeline({
		repeat: 0,
		repeatDelay: 1,
		paused: true,
	});

	mobileNavOpen.set(".we-small-screen-nav-container", {
		display: "block",
		opacity: "0",
	});
	mobileNavOpen.to(".we-small-screen-nav-container", {
		duration: 0.2,
		height: mobileNavHeight+"px",
		opacity: "1",
	});
	mobileNavOpen.set("html, body", {
		overflowY: "hidden"
	});
	//

	$(".we-small-screen-nav-container li.has-children").on('click',function (e) {
		e.preventDefault();
		if(!$(this).hasClass('we-header-sub-opened')) {
			$(this).find(".we-header-submenu").slideDown();
			$(this).addClass("we-header-sub-opened");
		} else {
			$(this).find(".we-header-submenu").slideUp();
			$(this).removeClass("we-header-sub-opened");
		}
		
	});

	$(window).resize(function () {
		screenHeight = window.innerHeight;
		mobileNavHeight = screenHeight - 48;
		if ($(".we-small-screen-nav-container").is(":visible")) {
			mobileNavOpen.to(".we-small-screen-nav-container", {
				duration: 0,
				height: mobileNavHeight + "px",
				opacity: "1",
			});
		}
	});

	//END SMALL SCREEN NAV

	//HAM EVENTS
	$(".hamburger").click(function (e) {
		e.preventDefault();

		if ($(this).hasClass("xfy") == false) {
			$(this).addClass("xfy");
			mobileNavOpen.play();
		} else {
			$(this).removeClass("xfy");
			mobileNavOpen.reverse();
		}
	});

	$(window).on("resize", function () {
		if (window.innerWidth > 1024) {
			mobileNavOpen.reverse();
			$(".hamburger").removeClass("xfy");
		}
	});
	//END HAM EVENTS

	/* END  HEADER NAV */

	/* END NAVIGATION */
});